module.exports = __webpack_public_path__ + "static/media/doctor-10.f14ddc0d.jpg";